// extracted by mini-css-extract-plugin
export default {"impact":"Impact_impact__B-N2a"};